import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

export default {
    install: function (Vue, name = "$dayjs") {
        Object.defineProperty(Vue.prototype, name, {value: dayjs});
        dayjs.extend(utc);
    }
};
